import type { Product } from "@decocms/apps-commerce/types";
import Image from "~/components/ui/Image";
import Slider from "~/components/ui/Slider";
import ProductCard, {
  Layout as CardLayout,
} from "~/components/product/ProductCard";
import SliderJS from "~/components/ui/SliderJS";
import { useId } from "react";

import ShelfDots from "./ShelfDots";

interface Props {
  products: Product[];
  productsPerScrollDesktop: 1 | 2 | 3 | 4 | 5 | 6;
  cardLayout?: CardLayout;
  /** @description Used for analytics event, will not appear on interface */
  title?: string;
}

const DEFAULT_CARD_LAYOUT: CardLayout = {
  basics: {
    contentAlignment: "Center",
  },
  hide: {
    allPrices: false,
    installments: false,
    productDescription: true,
    skuSelector: true,
  },
  onMouseOver: { image: "Zoom image" },
};

const PRODUCTS_PER_SCROLL_MAP = {
  1: "lg:w-full",
  2: "lg:w-2/4",
  3: "lg:w-1/3",
  4: "lg:w-[282px]",
  5: "lg:w-1/5",
  6: "lg:w-1/6",
};
function ImageNameAndBuyButtonShelf({
  products,
  productsPerScrollDesktop,
  cardLayout,
  title,
}: Props) {
  const id = useId();const finalCardLayout = { ...DEFAULT_CARD_LAYOUT, cardLayout };

  return (
    <div
      id={id}
      className="h-full grid grid-cols-[70px_1fr_70px] lg:grid-cols-[0_1fr_0] flex-col grid-rows-[0px_1fr_256px] shelfCrossSelling"
    >
      <Slider className="carousel carousel-center sm:carousel-end gap-0 col-span-full row-start-2 row-end-5 h-full w-full md:gap-6">
        {products?.map((product, index) => {
          return (
            <Slider.Item
              key={product.productID}
              index={index}
              className={`carousel-item flex justify-center w-1/2 ${
                PRODUCTS_PER_SCROLL_MAP[productsPerScrollDesktop]
              }`}
            >
              <ProductCard
                product={product}
                itemListName={title}
                layout={finalCardLayout}
                badgePosition="left-2 top-1 lg:left-5 lg:top-5"
              />
            </Slider.Item>
          );
        })}
      </Slider>
      <>
        <div className="relative lg:block hidden z-10 col-start-1 row-start-3">
          <Slider.PrevButton className="absolute right-1/2 bg-white h-[30px] w-[30px] flex justify-center items-center rounded-full border border-solid border-[#f9f9f9]">
            <Image
              loading="lazy"
              fetchPriority="low"
              decoding="async"
              width={12}
              height={23}
              src={"https://decoims.com/danielatombini/8fd8f8e4-9e5e-4d61-b837-d36704dd7994/home_slick-arrow.png"}
              alt="Previous item"
            />
          </Slider.PrevButton>
        </div>
        <div className="relative block z-10 col-start-3 row-start-3">
          <Slider.NextButton className="absolute left-1/2 bg-white h-[30px] w-[30px] flex justify-center items-center rounded-full border border-solid border-[#f9f9f9] rotate-180">
            <Image
              loading="lazy"
              fetchPriority="low"
              decoding="async"
              width={12}
              height={23}
              src={"https://decoims.com/danielatombini/8fd8f8e4-9e5e-4d61-b837-d36704dd7994/home_slick-arrow.png"}
              alt="Next item"
            />
          </Slider.NextButton>
        </div>
      </>
      <div className="block lg:hidden col-start-2 row-start-5 m-auto lg:mt-4 bullets">
        <ShelfDots products={products} />
      </div>

      <SliderJS rootId={id} infinite />
    </div>
  );
}

export default ImageNameAndBuyButtonShelf;
